import { Table, Theme } from '@yuno/design-system-web'
import { Grid } from '@yuno/design-system-web'
import styled from '@emotion/styled'

export const Wrapper = styled('div')<{
  children: JSX.Element | JSX.Element[]
  theme?: Theme
}>`
  border-bottom: 1px solid ${({ theme }) => theme.palette.grey[2]};
  border-radius: 4px;
  padding-bottom: 32px;
`
export const CardKey = styled(Grid)<{
  children: JSX.Element | JSX.Element[]
  theme?: Theme
}>`
  display: flex;
  background: ${({ theme }) => theme.palette.neutral.white[0]};
  border: 1px solid ${({ theme }) => theme.palette.grey[2]};
  border-radius: 4px;
  margin-top: 20px;
  flex-flow: column;
  padding: 24px;

  & .MuiTable-root {
    display: none;
    border-top: 1px solid rgb(236, 239, 242);
    border-radius: 8px;
    border-left: 1px solid rgb(236, 239, 242);
    border-right: 1px solid rgb(236, 239, 242);
  }

  @media (min-width: 1023px) {
    & .MuiTable-root {
      display: table;
    }
  }
`

export const TipWrapper = styled('div')`
  display: flex;
  padding-top: 32px;
`

export const TextContent = styled('div')`
  display: flex;
  flex-direction: column;
  padding-left: 16px;
`

export const IconWrapper = styled('div')<{
  theme?: Theme
}>`
  display: flex;

  @media (max-width: 1022px) {
    padding: 8px;
    justify-content: space-between;

    & .IconText {
      font-size: ${({ theme }) => theme.typography.small.regular.fontSize};
      color: ${({ theme }) => theme.palette.grey[5]};
    }
  }

  & span {
    margin-left: 8px;
    margin-right: 32px;
  }
`

export const IconContent = styled('div')<{
  theme?: Theme
}>`
  display: flex;
  align-items: center;
`

export const CardMobile = styled('div')<{
  theme?: Theme
}>`
  display: flex;
  flex-direction: column;
  border: 1px solid ${({ theme }) => theme.palette.grey[2]};
  border-radius: 8px;
  margin-bottom: 16px;

  @media (min-width: 1023px) {
    display: none;
  }

  &:last-child {
    margin-bottom: 0;
  }
`

export const RowCardMobile = styled('span')<{
  theme?: Theme
}>`
  margin-inline: 8px;
  padding: 16px 8px;
  color: ${({ theme }) => theme.palette.neutral.black};
  border-bottom: 1px solid ${({ theme }) => theme.palette.grey[2]};
`

export const FIVE_SECONDS = 5000
